import { IDeleteCategoriaAssistenciaUseCase } from "../../../presentation/useCases/delete/delete_categoria_assistencia_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * DeleteCategoriaAssistenciaUseCase
 */

export class DeleteCategoriaAssistenciaUseCase implements IDeleteCategoriaAssistenciaUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async deleteCategoriaAssistencia(
    idCategoriaAssistencia: number,
  ): Promise<void> {
    await this.repository.deleteCategoriaAssistencia(idCategoriaAssistencia);
  }
}
